import BlogPage from 'src/views/Marketing/Blog/components/BlogPage';
import Footer from 'src/views/Marketing/components/Footer';
import NavBar from 'src/views/Marketing/components/NavBar';
import { ScrollView, StyleSheet } from 'react-native';
import * as Constants from 'src/constants';

export default function Page() {
  return (
    <ScrollView style={styles.scrollView}>
      <NavBar />
      <BlogPage
        author='OneShop Team'
        dateTime='2022-08-05'
        tag='Grailed'
        title='Grailed Guide 101: Understanding Grailed Sales Tax'
      >
        <p>
          There are many things to consider when selling on Grailed. You need to take into account your shipping costs,
          the items you're selling, and sales tax regulations to avoid any potential tax implications.
        </p>
        <p>
          Sales tax is an essential topic for both buyers and sellers. The buyer needs to know how much they will be
          paying in sales tax, and the seller needs to be aware of what information they need to provide. The addition
          of sales tax can be a bit shocking for buyers who were expecting to see lower prices on their purchases.
        </p>
        <p>
          Additional fees are confusing for most buyers and can discourage them from making purchases. In order to
          prevent this from happening, sellers must be well aware of their state sales tax to provide the correct
          information to their buyers. This article will cover the basics of sales tax, how sales tax works for buyers,
          and how sellers can apply for sales tax exemptions.
        </p>

        <h3>What is a State Sales Tax</h3>
        <p>
          Sales tax is a consumption tax charged by a government to consumers who purchase goods or services. The main
          objective of imposing this tax on purchases is to generate state revenue and provide public project funding.
        </p>
        <p>As of October 2021, Grailed is required to collect sales tax to the following U.S. States:</p>
        <ul>
          <li>Alabama</li>
          <li>Alaska</li>
          <li>Arizona</li>
          <li>Arkansas</li>
          <li>California</li>
          <li>Colorado</li>
          <li>Connecticut</li>
          <li>Florida</li>
          <li>Georgia</li>
          <li>Hawaii</li>
          <li>Idaho</li>
          <li>Illinois</li>
          <li>Indiana</li>
          <li>Iowa</li>
          <li>Kansas</li>
          <li>Kentucky</li>
          <li>Louisiana</li>
          <li>Maine</li>
          <li>Maryland</li>
          <li>Massachusetts</li>
          <li>Michigan</li>
          <li>Minnesota</li>
          <li>Mississippi</li>
          <li>Nebraska</li>
          <li>Nevada</li>
          <li>New Jersey</li>
          <li>New Mexico</li>
          <li>New York</li>
          <li>North Carolina</li>
          <li>North Dakota</li>
          <li>Ohio</li>
          <li>Oklahoma</li>
          <li>Pennsylvania</li>
          <li>Rhode Island</li>
          <li>South Carolina</li>
          <li>South Dakota</li>
          <li>Tennessee</li>
          <li>Texas</li>
          <li>Utah</li>
          <li>Virginia</li>
          <li>Vermont</li>
          <li>Washington</li>
          <li>Washington, D.C.</li>
          <li>West Virginia</li>
          <li>Wisconsin</li>
          <li>Wyoming</li>
        </ul>
        <p>
          Sales taxes are typically calculated as a percentage, which means that if you spend $100 on an item, you will
          be taxed 4-8% for that purchase. These computations vary depending on your buyer's state and are automatically
          applied during checkout. Grailed collects and processes this on behalf of sellers to ensure all sales taxes
          are forwarded to the appropriate state government.
        </p>

        <h3>How Sales Tax affect Sellers</h3>
        <p>
          Unlike other marketplaces, Grailed sellers no longer have to manually collect and remit sales taxes from their
          buyers who live in a state requiring this tax. Grailed does all the work and will automatically calculate the
          tax based on the total sale amount, including the shipping fees.
        </p>
        <p>
          Sales tax is not part of the Grailed selling fee but is a law required by certain states within the U.S.
          Grailed sellers do not need to adjust their prices as this tax is not part of the purchase price and is a
          required tax that buyers must pay on top of their purchases. Grailed is responsible for collecting these
          taxes, so sellers don’t need to do anything differently.
        </p>

        <h3>How Sales Tax Works for Buyers</h3>
        <p>
          While state tax doesn't affect sellers, it is a different story for buyers. If you are a seller who regularly
          buys on Grailed, you may have noticed sales tax added to your purchases. Some states now require the
          collection of sales tax on all purchases made from the internet, especially on marketplaces.
        </p>
        <p>
          Grailed and many other marketplaces also started collecting sales tax, especially for buyers living in a state
          that requires it. Since sales taxes on marketplaces is relatively new, you don't need to worry about paying
          sales taxes on your past purchases. All of your past purchases will not be part of the regulation, and all
          your new purchases will have sales tax automatically applied during checkout.
        </p>

        <h3>How Does Sales Tax Work for Sellers Outside the U.S</h3>
        <p>
          Like sellers residing in the U.S., sellers living overseas or outside the U.S. don't need to do anything or
          adjust their prices accordingly to keep up with sales tax. Sales tax varies depending on the buyers' states,
          and sales tax is automatically computed and applied during checkout.
        </p>
        <p>
          If you're a seller residing outside the U.S. and one of your buyers is living within the U.S. that requires
          sales tax, your buyer is responsible for paying the purchase price, shipping fees, and the added sales tax.
        </p>
        <p>
          In comparison, if you're a seller based in the U.S., and someone buys an item from you outside the U.S., that
          buyer is not required to pay U.S. sales tax. Nevertheless, Grailed ensures that all its users are
          tax-compliant, even those users outside the U.S. Grailed provides timely updates for any changes in
          regulations to keep their users up to date.
        </p>

        <h3>How Sales Taxes Work for Payment Processors like PayPal and Stripe</h3>
        <p>
          Sales tax is automatically calculated and added for payments made on Paypal and Stripe. These payment
          processors include sales tax in your gross sales earnings, so the initial amount reflected in your account can
          appear higher than your actual earnings.
        </p>
        <p>
          Aside from your buyer's payment for the purchase, the sales tax is also included in the initial earnings.
          Before the amount can be deposited to you, sales tax will be deducted and passed to Grailed, which the
          platform is required to remit to the relevant state government.
        </p>

        <h4>Why does it appear higher?</h4>
        <p>
          You might be wondering why these partner fees appear higher than your actual earnings. This is because these
          payment processors include the sales tax amount with Grailed’s fee. The platform does not profit from here,
          and Grailed’s fee structure is still the same.
        </p>

        <h3>How to Apply for Sales Exemption</h3>
        <p>
          Most sellers on Grailed are subject to sales tax. The only exception is if their state has granted the seller
          a sales tax exemption. In that case, they can apply for an exemption from a specific state or from all states
          and get it approved to avoid paying taxes when making transactions with buyers who live in those states.
        </p>
        <p>
          If you already got your valid exemption certification, all you have to do is submit it to salestax@grailed
          with the following information:
        </p>
        <ul>
          <li>Full name</li>
          <li>Grailed username</li>
          <li>Email address registered with your Grailed account</li>
          <li>PDF file of your valid exemption certificate</li>
        </ul>
        <p>
          After sending all the required forms and information, Grailed will review it, and you will receive a
          notification once your sales tax exemption has been granted.
        </p>

        <h3>Do More with OneShop</h3>
        <p>
          Selling on all online marketplaces comes with tax responsibilities. While the buyer shoulders sales tax,
          sellers must be aware of it and provide the correct information to their buyers to avoid order cancellations
          or disappointed customers.
        </p>
        <p>
          Editing your listings can take 5-15 mins which can be tedious and time-consuming. Fortunately, there’s a
          reliable automation service like OneShop that you can trust! It allows you to quickly draft listings with the
          correct information and crosslist them to other marketplaces to reach more audiences and increase your chances
          of making a sale.
        </p>
        <p>
          OneShop also added the smart listing prices features. Now, you can have different prices for each marketplace
          with marketplace fees automatically calculated, so you don’t have to worry about manually computing your
          product prices.
        </p>
        <p>
          OneShop’s intelligent system makes it seamless for resellers like you to do more things without doing more
          work. From tracking sales, setting goals, ordering shipping supplies, scheduling package pickups, to looking
          up an item’s registration number– OneShop got you covered!
        </p>
        <p>
          Make OneShop part of your business and experience the difference it makes to your reselling journey. Be one of
          the thousands of online resellers who trust OneShop, which has proven to increase sales and grow their
          business. Sign-up <a href='https://tools.oneshop.com/signup'>now</a>, set up your account in less than three
          minutes, and enjoy a <>{Constants.Marketing.TrialDuration}</>-day free trial!
        </p>
      </BlogPage>
      <Footer />
    </ScrollView>
  );
}

const styles = StyleSheet.create({
  scrollView: {
    flex: 1,
  },
});
